export default [
  {
    path: '/app/seguridad/usuarios',
    name: 'rt-seguridad-usuarios',
    component: () => import('@/views/erp/seguridad/usuario/UsuarioList.vue'),
    meta: {
      resource: 'rt-seguridad-usuarios',
      pageTitle: 'Usuarios',
      breadcrumb: [
        {
          text: 'Seguridad',
        },
        {
          text: 'Usuarios',
          active: true,
        },
      ],
    },
  },
  {
    path: '/seguridad/modulos',
    name: 'rt-seguridad-modulos',
    component: () => import('@/views/erp/seguridad/modulo/ModuloList.vue'),
    meta: {
      resource: 'rt-seguridad-modulos',
      pageTitle: 'Módulos',
      breadcrumb: [
        {
          text: 'Seguridad',
        },
        {
          text: 'Módulos',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/seguridad/perfiles',
    name: 'rt-seguridad-perfiles',
    component: () => import('@/views/erp/seguridad/perfil/PerfilList.vue'),
    meta: {
      resource: 'rt-seguridad-perfiles',
      pageTitle: 'Perfiles',
      breadcrumb: [
        {
          text: 'Seguridad',
        },
        {
          text: 'Perfiles',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/seguridad/permisos',
    name: 'rt-seguridad-permisos',
    component: () => import('@/views/erp/seguridad/permiso/Permiso.vue'),
    meta: {
      resource: 'rt-seguridad-permisos',
      pageTitle: 'Permisos de Perfiles',
      breadcrumb: [
        {
          text: 'Seguridad',
        },
        {
          text: 'Permisos',
          active: true,
        },
      ],
    },
  },
]
